module.exports = __webpack_public_path__ + "static/hotel-501bea3265792ff8558ea11810d2d66d.jpg";